import { createApp } from 'vue';
import Cart from '@vueApp/views/cart/CartView.vue';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';

class CartController {
  init() {
    translator.getLanguages().then(() => {
      const cartApp = createApp(Cart);
      cartApp.mount('#root-cart-view');
    });
  }
}

const cartController = new CartController();
cartController.init();
